import { createStore } from 'vuex';
import createPersistedState from "vuex-persistedstate";
import { annotation } from './annotation.module.js'
import { asset } from './asset.module.js'
import { asset_sub_type } from './asset_sub_type.module.js'
import { company } from './company.module.js'
import { country } from './country.module.js'
import { emo } from './emo.module.js'
import { emo_template } from './emo_template.module.js'
import { energy_source } from './energy_source.module.js'
import { energy_use_cat } from './energy_use_cat.module.js'
import { image } from './image.module.js'
import { instance } from './instance.module'
import { issue } from './issue.module.js'
import { issue_category } from './issue_category.module.js'
import { location } from './location.module.js'
import { meter } from './meter.module.js'
import { note } from './note.module.js'
import { site } from './site.module.js'
import { site_primary_function } from './site_primary_function.module.js'
import { unit } from './unit.module.js'
import { user } from './user.module.js'

export default createStore({
  //devtools: false,
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    annotation,
    asset,
    asset_sub_type,
    company,
    country,
    emo,
    emo_template,
    energy_source,
    energy_use_cat,
    image,
    instance,
    issue,
    issue_category,
    location,
    meter,
    note,
    site,
    site_primary_function,
    unit,
    user
  },
  getters: {
    getObjectByUUID(state, getters) {
      return function(obj_type, uuid) {
        switch (obj_type) {
          case "Location":
            return getters.getLocationByUUID(uuid);
          case "Asset":
            return getters.getAssetByUUID(uuid);
          case "Emo":
            return getters.getEmoByUUID(uuid);
          case "Meter":
            return getters.getMeterByUUID(uuid);
          case "Site":
            return getters.getSite(uuid);
          case "Note":
            return getters.getNoteByUUID(uuid);
          case "Image":
            return getters.getImage(uuid);  
          case "Issue":
            return getters.getIssueByUUID(uuid);
          default:
            return null;          
        }
      }
    }
  },
  plugins:[
    createPersistedState({ key: 'app4aims' })
  ],
  strict: true
})
